var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67.3914,
    height: 67.3914,
    fill: "#1B436A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0191 58.9676C50.1691 58.9676 44.3894 57.6923 38.6798 55.1417C32.9703 52.5912 27.7755 48.9759 23.0956 44.2959C18.4156 39.616 14.8004 34.4212 12.2498 28.7117C9.69921 23.0021 8.42392 17.2224 8.42392 11.3724C8.42392 10.5301 8.70472 9.82806 9.26631 9.26646C9.82791 8.70487 10.5299 8.42407 11.3723 8.42407H22.7446C23.3998 8.42407 23.9848 8.64637 24.4996 9.09097C25.0144 9.53556 25.3186 10.0621 25.4122 10.6705L27.2373 20.4984C27.3309 21.2472 27.3075 21.8789 27.1671 22.3937C27.0267 22.9085 26.7693 23.3531 26.3949 23.7275L19.5856 30.6071C20.5216 32.3386 21.6331 34.0117 22.9201 35.6263C24.2071 37.2409 25.6228 38.797 27.1671 40.2946C28.6179 41.7454 30.1389 43.0908 31.7301 44.331C33.3213 45.5712 35.0061 46.7061 36.7844 47.7357L43.3832 41.137C43.8044 40.7158 44.3543 40.3999 45.0329 40.1893C45.7115 39.9787 46.3784 39.9202 47.0336 40.0138L56.7211 41.9794C57.3763 42.1665 57.9144 42.5058 58.3356 42.9972C58.7568 43.4886 58.9674 44.0385 58.9674 44.6469V56.0192C58.9674 56.8616 58.6866 57.5636 58.125 58.1252C57.5635 58.6868 56.8615 58.9676 56.0191 58.9676Z",
    fill: "#1B436A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLight);
export default __webpack_public_path__ + "static/media/call_light.4beed1816617f29aa54b1b0a52187109.svg";
export { ForwardRef as ReactComponent };